<template>
  <div class="c-favorites">
    <div v-if="bookmarks.length > 0" class="c-favorites__wrapper">
      <div v-for="bookmark in bookmarks" :key="bookmark.id" class="c-favorites__thumbnail">
        <bookmark-thumbnail
        :book="bookmark.book"
        :page="bookmark.page"
        :src="`${$root.$config.booksync_url}/pubs/${bookmark.book}/thumbnail/page${bookmark.page}.png?token=${encodeURIComponent(accessToken)}`"
        />
      </div>
    </div>
    <div v-else class="c-favorites__empty">
      <h3 class="c-favorites__no-content">{{ $t('FAVORITES_NO_CONTENT') }}</h3>
      <p class="c-favorites__not-added">{{ $t('FAVORITES_NOT_ADDED') }}</p>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import BookmarkThumbnail from '@/components/BookmarkThumbnail'

export default {
  name: 'Favorites',

  components: {
    'bookmark-thumbnail': BookmarkThumbnail
  },

  computed: {
    ...mapState('user', {
      accessToken: state => state.accessToken
    }),

    ...mapGetters({
      bookmarks: 'bookmarks/getBookmarks'
    }),
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_vars.scss';
@import '@/assets/scss/_mixin.scss';

.c-favorites__wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.c-favorites__empty {
  @include empty();
}

.c-favorites__thumbnail {
  margin: 0 1.75em 3em 1.75em;
}

.c-favorites__no-content {
  font-size: 18px;
  font-weight: bold;
  color: $dark-blue;
  margin-bottom: 1em;
}

.c-favorites__not-added {
  font-size: 14px;
  color: $black;
}
</style>
